export const GET_DOCUMENTS_PENDING = "GET_DOCUMENTS_PENDING";
export const GET_DOCUMENTS_SUCCESS = "GET_DOCUMENTS_SUCCESS";
export const GET_DOCUMENTS_FAILURE = "GET_DOCUMENTS_FAILURE";

export const ADD_DOCUMENTS_PENDING = "ADD_DOCUMENTS_PENDING";
export const ADD_DOCUMENTS_SUCCESS = "ADD_DOCUMENTS_SUCCESS";
export const ADD_DOCUMENTS_FAILURE = "ADD_DOCUMENTS_FAILURE";

export const UPLOAD_DOCUMENTS_PENDING = "UPLOAD_DOCUMENTS_PENDING";
export const UPLOAD_DOCUMENTS_SUCCESS = "UPLOAD_DOCUMENTS_SUCCESS";
export const UPLOAD_DOCUMENTS_FAILURE = "UPLOAD_DOCUMENTS_FAILURE";

export const EDIT_DOCUMENTS_PENDING = "EDIT_DOCUMENTS_PENDING";
export const EDIT_DOCUMENTS_SUCCESS = "EDIT_DOCUMENTS_SUCCESS";
export const EDIT_DOCUMENTS_FAILURE = "EDIT_DOCUMENTS_FAILURE";

export const DELETE_DOCUMENTS_PENDING = "DELETE_DOCUMENTS_PENDING";
export const DELETE_DOCUMENTS_SUCCESS = "DELETE_DOCUMENTS_SUCCESS";
export const DELETE_DOCUMENTS_FAILURE = "DELETE_DOCUMENTS_FAILURE";

export const DOWNLOAD_DOCUMENTS_PENDING = "DOWNLOAD_DOCUMENTS_PENDING";
export const DOWNLOAD_DOCUMENTS_SUCCESS = "DOWNLOAD_DOCUMENTS_SUCCESS";
export const DOWNLOAD_DOCUMENTS_FAILURE = "DOWNLOAD_DOCUMENTS_FAILURE";

export const DOWNLOAD_MISSING_DOCUMENTS_PENDING =
  "DOWNLOAD_MISSING_DOCUMENTS_PENDING";
export const DOWNLOAD_MISSING_DOCUMENTS_SUCCESS =
  "DOWNLOAD_MISSING_DOCUMENTS_SUCCESS";
export const DOWNLOAD_MISSING_DOCUMENTS_FAILURE =
  "DOWNLOAD_MISSING_DOCUMENTS_FAILURE";
